import { _keys, cloneObj, exists, Module } from '@nu-art/ts-common';
import { ABTestValue } from '@app/org-shared';
import { ModuleFE_AdvisorSession } from '@app/advisor-frontend';
import { ModuleFE_AdvisorAnalytics } from '../../_analytics/consts.js';
import { StorageKey, ThunderDispatcher } from '@nu-art/thunderstorm-frontend';
const dispatcher = new ThunderDispatcher('__onABTestingChanged');
class ModuleFE_AdvisorABTesting_Class extends Module {
    abConfig;
    storageKey;
    //######################### Internal Logic #########################
    getStorageKey = () => {
        if (!this.storageKey) {
            const encounterId = ModuleFE_AdvisorSession.getCurrentEncounterId();
            const key = `ab-testing-config__${encounterId}`;
            this.storageKey = new StorageKey(key);
        }
        return this.storageKey;
    };
    getConfig = () => {
        if (!this.abConfig) {
            const storageKey = this.getStorageKey();
            this.abConfig = storageKey?.get();
        }
        return this.abConfig;
    };
    //######################### Public Logic #########################
    setDefaultValues = (config) => {
        if (!config)
            return;
        const storageKey = this.getStorageKey();
        const abConfig = cloneObj(this.getConfig() ?? {});
        const changedKeys = [];
        _keys(config).forEach(key => {
            if (exists(abConfig[key]))
                return;
            switch (config[key]) {
                case ABTestValue.Enabled_DefaultFalse:
                    abConfig[key] = false;
                    changedKeys.push(key);
                    break;
                case ABTestValue.Enabled_DefaultTrue:
                    abConfig[key] = true;
                    changedKeys.push(key);
                    break;
            }
        });
        if (!changedKeys.length)
            return;
        this.abConfig = abConfig;
        storageKey.set(this.abConfig);
        dispatcher.dispatchAll(changedKeys);
    };
    getValue = (key) => {
        const abValue = ModuleFE_AdvisorSession.getABTestingValue(key);
        const actualValue = this.getConfig()?.[key];
        return { abValue, actualValue: actualValue ?? false };
    };
    setValue = (key, value) => {
        const current = this.getValue(key);
        if (current.abValue === ABTestValue.Disabled || current.actualValue === value)
            return;
        const storageKey = this.getStorageKey();
        if (!this.abConfig)
            this.abConfig = {};
        this.abConfig[key] = value;
        storageKey.set(cloneObj(this.abConfig));
        dispatcher.dispatchAll([key]);
        ModuleFE_AdvisorAnalytics.trigger.settings.settings_changed({
            settingLabel: `abTesting_${key}`,
            fromValue: String(current.actualValue),
            toValue: String(value),
        });
    };
}
export const ModuleFE_AdvisorABTesting = new ModuleFE_AdvisorABTesting_Class();
//# sourceMappingURL=ModuleFE_AdvisorABTesting.js.map